/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type FormBodyProps = {
    children: React.ReactNode | React.ReactNode[]
    className?: string
}

const UiFormBody: React.FC<FormBodyProps> = ({ children, className }) => {
    return (
        <div
            className={clsx(
                'UiFormBody flex-1 min-h-0 overflow-y-auto text-sm leading-6',
                className
            )}
        >
            {children}
        </div>
    )
}

export default UiFormBody
